import { useEffect, useState } from 'react';
import apiClient from '../../../services/apiService';

/**
 * Fetches a dashboard split endpoint returning [{ name, value, color }].
 * On failure: logs, exposes error, and yields [] (charts render their empty state).
 */
export function useDashboardSplit(endpoint, params) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const paramsKey = JSON.stringify(params || {});

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const res = await apiClient.get(endpoint, params ? { params } : undefined);
        if (!cancelled) {
          setData(res.data.data || res.data || []);
          setError(null);
        }
      } catch (e) {
        console.error(`Error fetching ${endpoint}:`, e);
        if (!cancelled) {
          setError('Failed to load chart data');
          setData([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, paramsKey]);

  return { data, loading, error };
}
